import { ORGANIZATION_ID, SERVICE_OGP_IMAGE, SITE_URL } from '../constants'

/** TOP ページ用 Corporation スキーマ（schema_base.md 準拠 + @id） */
export const topCorporationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Corporation',
  '@id': ORGANIZATION_ID,
  name: '株式会社アイスリーデザイン',
  legalName: '株式会社アイスリーデザイン',
  alternateName: 'i3DESIGN Co.,Ltd.',
  slogan: 'Design × AI × Engineering で、日本のITを再起動する。i3DESIGNはAI駆動のデジタルエンジニアリング企業です。',
  description:
    'AIエージェント、モダンスタック、CI/CD、DevOps、UX/UIをフル活用した開発スタイルで、顧客のモダナイゼーションとAIシフトを実装します。',
  founder: '芝 陽一郎',
  foundingDate: '2006-07-26',
  url: `${SITE_URL}/`,
  logo: SERVICE_OGP_IMAGE,
  image: SERVICE_OGP_IMAGE,
  telephone: '+81-3-6419-7700',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '東京',
    addressRegion: '東京都',
    addressCountry: 'JP',
    postalCode: '1070052',
    streetAddress: '東京都港区赤坂八丁目１番22号 NMF青山一丁目ビル３階',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    url: `${SITE_URL}/contact/`,
    telephone: '+81-3-6419-7700',
    areaServed: 'JP',
    availableLanguage: ['Japanese', 'English'],
  },
  areaServed: {
    '@type': 'Country',
    name: 'Japan',
  },
  knowsAbout: ['アプリ開発', 'クラウドネイティブ', 'AI駆動開発', 'デザインシステム', 'UX/UIデザイン'],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'i3DESIGNサービス',
    itemListElement: [
      {
        '@type': 'OfferCatalog',
        name: 'モダンアプリケーション開発',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'AI駆動開発支援',
              url: `${SITE_URL}/services/ai-driven-development/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'アプリケーション開発',
              url: `${SITE_URL}/services/application-development/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'クラウドネイティブ',
              url: `${SITE_URL}/services/cloudnative/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'モダナイゼーション',
              url: `${SITE_URL}/services/modernization/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: '特徴量エンジニアリングと生成AI',
              url: `${SITE_URL}/services/feature-engineering/`,
            },
          },
        ],
      },
      {
        '@type': 'OfferCatalog',
        name: 'デジタルプロダクトデザイン',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'デザインシステム構築支援',
              url: `${SITE_URL}/services/design-system/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'プロトタイピング・仮説検証',
              url: `${SITE_URL}/services/prototyping/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'UX/UI改善',
              url: `${SITE_URL}/services/uxui-improvement/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'フロントエンド開発',
              url: `${SITE_URL}/services/frontend-dev/`,
            },
          },
        ],
      },
      {
        '@type': 'OfferCatalog',
        name: 'プロダクト成長支援',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'PdM/PMM体制実行支援',
              url: `${SITE_URL}/services/pdm-pmm/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: '新規事業プロジェクト実行支援',
              url: `${SITE_URL}/services/business-startup-support/`,
            },
          },
        ],
      },
      {
        '@type': 'OfferCatalog',
        name: '製品・サービス',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: { '@type': 'Service', name: 'Phennec', url: `https://phennec.ai/` },
          },
          {
            '@type': 'Offer',
            itemOffered: { '@type': 'Service', name: 'flamingo', url: `${SITE_URL}/services/flamingo/` },
          },
          {
            '@type': 'Offer',
            itemOffered: { '@type': 'Service', name: 'ZEBRA', url: `${SITE_URL}/services/zebra/` },
          },
          {
            '@type': 'Offer',
            itemOffered: { '@type': 'Service', name: 'ELAND', url: `https://eland.jp/` },
          },
        ],
      },
    ],
  },
  memberOf: [
    { '@type': 'Organization', name: 'AWSセレクトティアサービスパートナー' },
    { '@type': 'Organization', name: 'Amazon ECS Delivery Partner' },
    { '@type': 'Organization', name: 'GitLab Open Partner' },
    { '@type': 'Organization', name: '特定非営利活動法人 人間中心設計推進機構' },
    { '@type': 'Organization', name: 'AI駆動開発コンソーシアム' },
  ],
  sameAs: [
    'https://x.com/i3design_jp',
    'https://www.facebook.com/i3DESIGN',
    'https://www.linkedin.com/company/i3design-co-ltd-/',
    'https://note.com/i3design_jp',
    'https://note.com/i3design_design',
  ],
}
